//https://stackoverflow.com/a/67994693
export const getFilenameFromContentDisposition = (disposition: string | null): string | null => {
  if (!disposition) return null;

  const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i;
  const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

  let fileName = '';
  if (utf8FilenameRegex.test(disposition)) {
    const result = utf8FilenameRegex.exec(disposition);
    if (!result) return null;
    return decodeURIComponent(result[1]);
  } else {
    // prevent ReDos attacks by anchoring the ascii regex to string start and
    //  slicing off everything before 'filename='
    const filenameStart = disposition.toLowerCase().indexOf('filename=');
    if (filenameStart >= 0) {
      const partialDisposition = disposition.slice(filenameStart);
      const matches = asciiFilenameRegex.exec(partialDisposition);
      if (matches != null && matches[2]) {
        fileName = matches[2];
      }
    }
  }
  return fileName;
};
